import { semanticColor, space, typeStyle } from '@beautyburst/tokens';
import { customerHref } from '../base-path.ts';
import { ORDER_PROBLEM_SUPPORT_COPY, supportEmailAddress } from './orders.tsx';

export function OrderHelpScreen() {
  return (
    <section aria-labelledby="order-help-title" style={{ display: 'grid', gap: space[4] }}>
      <h1
        id="order-help-title"
        style={{ ...typeStyle('headingLg'), color: semanticColor.textPrimary, margin: 0 }}
      >
        Order help
      </h1>
      <p style={{ ...typeStyle('body'), color: semanticColor.textPrimary, margin: 0 }}>
        {ORDER_PROBLEM_SUPPORT_COPY}
      </p>
      <section aria-labelledby="order-issue-title">
        <h2
          id="order-issue-title"
          style={{ ...typeStyle('headingSm'), color: semanticColor.textPrimary }}
        >
          Contact support about an order problem
        </h2>
        <p style={{ ...typeStyle('body'), color: semanticColor.textSecondary }}>
          Support can review damaged, incorrect, missing, cancelled, undeliverable, failed,
          duplicate, or otherwise defective orders.
        </p>
        <a
          data-testid="link-contact-order-support"
          href={`mailto:${supportEmailAddress()}?subject=${encodeURIComponent('Order help')}`}
        >
          Contact Beauty Burst Support
        </a>
      </section>
      <a data-testid="link-order-help-orders" href={customerHref('/orders')}>
        View your orders
      </a>
    </section>
  );
}
